import {
  API_BASE_AZURE_URL,
  API_BASE_URL,
  API_BASE_ANNEX_URL,
  API_BASE_ANNEX_AZURE_URL,
} from '@/common/utils/request.const'

/**
 * url 을 받아 프로토콜이 없을 경우 추가 하고
 * API_URL_LIST 에 있는 주소와 비교하여 같은 주소인지 확인
 * 같은 주소 여부 리턴
 * @param url
 * @returns {boolean}
 */
export const isApiUrl = (url) => {
  const hasProtocol = url.match('(http|https)://')

  if (!hasProtocol) {
    url = `https://${url}`
  }

  const parsedUrl = new URL(url)

  const API_URL_LIST = [
    API_BASE_URL,
    API_BASE_AZURE_URL,
    API_BASE_ANNEX_URL,
    API_BASE_ANNEX_AZURE_URL,
  ]

  return API_URL_LIST.some((apiUrl) => parsedUrl?.origin === apiUrl)
}
